import PropTypes from 'prop-types'
import React from 'react'
import BoldLabelAndContent from '../../molecules/BoldLabelAndContent'

const Answer = props => {
  return (
    <BoldLabelAndContent label={props.question.payload?.label} content={props.answer} el="li">
      {props.children}
    </BoldLabelAndContent>
  )
}

const Response = props => {
  return (
    <BoldLabelAndContent label={`${props.question.payload?.label}:`} content={props.answer} className="mb-2" el="li">
      {props.children}
    </BoldLabelAndContent>
  )
}

const QuestionType = {
  subtype: 'Pregunta',
  Answer,
  TaskResponse: Response,
  Response,
  Template: () => {
    throw new Error('Componente para plantilla no implementado')
  },
  Form: () => {
    throw new Error('Componente para creador de formularios no implementado')
  }
}

export default QuestionType

Answer.propTypes = {
  answer: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node,
  question: PropTypes.object
}

Response.propTypes = {
  answer: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  children: PropTypes.node,
  question: PropTypes.object.isRequired
}
